/**
 * @generated SignedSource<<b3c7c3a957fcf934f5e909f6dd934b7f>>
 * @relayHash 5bcccd04455cf36ba37e56733ea296c8
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

// @relayRequestID 5bcccd04455cf36ba37e56733ea296c8

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "ccnId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "settings"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "ccnId",
        "variableName": "ccnId"
      },
      {
        "kind": "Variable",
        "name": "settings",
        "variableName": "settings"
      }
    ],
    "concreteType": "BasicResponse",
    "kind": "LinkedField",
    "name": "updateCcnSettings",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateCcnSettingsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UpdateCcnSettingsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "5bcccd04455cf36ba37e56733ea296c8",
    "metadata": {},
    "name": "UpdateCcnSettingsMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

node.hash = "e5b684feaa6c9fbc8686134149c14ccf";

export default node;
